
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import ClassPage from './pages/ClassPage';
import NotesHub from './pages/NotesHub';
import ExamPrep from './pages/ExamPrep';
import FAQs from './pages/FAQs';
import Contact from './pages/Contact';
import { PrivacyPolicy, Disclaimer } from './pages/Legal';

const App: React.FC = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/notes-hub" element={<NotesHub />} />
            <Route path="/class/:classId" element={<ClassPage />} />
            <Route path="/exam-prep" element={<ExamPrep />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/subjects" element={<NotesHub />} /> {/* Redirecting for structure consistency */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
